import React, { useEffect } from "react";
import ContentCards from "./ContentCards";
import categoryFilter from "../ArrayFilter";
import BlogData from "../BlogData";
export default function ContentCardsSpecific({ match }) {
  const cardData = categoryFilter(BlogData, match.params.category);
  useEffect(() => {
    document.title = match.params.category.splite("-").join(" ");
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, [match.params.category]);
  return <ContentCards cardData={cardData} />;
}
